module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 4@2x.0a42e9a4.png";